import {
  TERMINAL_INSTALLED_APP_FIELD_FILTER_CLEAN_REQUEST,
  TERMINAL_INSTALLED_APP_FIELD_FILTER_REQUEST,
  TERMINAL_INSTALLED_APP_FIELD_FILTER_REQUEST_SUCCESS,
  TERMINAL_INSTALLED_APP_FIELD_FILTER_REQUEST_FAILURE,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const terminalInstalledAppFilterFieldReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TERMINAL_INSTALLED_APP_FIELD_FILTER_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TERMINAL_INSTALLED_APP_FIELD_FILTER_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case TERMINAL_INSTALLED_APP_FIELD_FILTER_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case TERMINAL_INSTALLED_APP_FIELD_FILTER_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export default terminalInstalledAppFilterFieldReducer;
